import { render, staticRenderFns } from "./MemberList.vue?vue&type=template&id=2062fef4&scoped=true&"
import script from "./MemberList.vue?vue&type=script&lang=js&"
export * from "./MemberList.vue?vue&type=script&lang=js&"
import style0 from "./MemberList.vue?vue&type=style&index=0&id=2062fef4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2062fef4",
  null
  
)

export default component.exports